import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const CreateContrato = () => {

  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [entidades, setEntidades] = useState([]);

  const [formData, setFormData] = useState({
    num_contrato: "",
    id_entidad: "",
    presupuesto: "",
    start_date: "",
    end_date: "",
    objeto: "",
    valor_contrato: "",
    doc_contra_partida: null
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // =======================
  // INPUTS
  // =======================
  const handleChange = (e) => {

    const { name, value, files } = e.target;

    if (name === "doc_contra_partida") {
      setFormData({ ...formData, doc_contra_partida: files[0] });
      return;
    }

    // solo números
    if (name === "valor_contrato" && !/^\d*$/.test(value)) return;

    setFormData({ ...formData, [name]: value });
  };

  // =======================
  // SUBMIT
  // =======================
  const handleSubmit = async (e) => {

    e.preventDefault();
    setError("");
    setSuccess("");

    const required = [
      "num_contrato",
      "id_entidad",
      "presupuesto",
      "start_date",
      "end_date",
      "objeto",
      "valor_contrato"
    ];

    const empty = required.filter(
      (f) => !formData[f] || formData[f].toString().trim() === ""
    );

    if (empty.length > 0) {
      setError("Hay campos obligatorios incompletos");
      return;
    }

    try {

      const form = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          form.append(key, formData[key]);
        }
      });

      const res = await authFetch(ENDPOINTS.createContratoProyectos, {
        method: "POST",
        body: form
      });

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Contrato creado correctamente");

      setTimeout(() => {
        navigate("/session/mod_proyectos/contrato_proyectos/contrato");
      }, 1500);

    } catch (err) {
      console.error(err);
      setError("Error en el servidor");
    }
  };

  // =======================
  // CARGAR ENTIDADES
  // =======================
  useEffect(() => {

    const loadEntidades = async () => {
      try {
        const res = await authFetch(ENDPOINTS.getEntityActive);

        if (res.success && Array.isArray(res.entidades)) {
            setEntidades(res.entidades);
        } else {
            setEntidades([]);
        }
      } catch (err) {
        console.error("Error cargando entidades", err);
      }
    };

    loadEntidades();

  }, [authFetch]);

  return (
    <div className="p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center m-3">
        <h3>Crear Contrato</h3>

        <button
          type="button"
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/mod_proyectos/contrato_proyectos/contrato")}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
      </div>

      {/* FORM */}
      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {/* ALERTAS */}
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* FILA 1 */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Número contrato *</label>
            <input
              type="text"
              name="num_contrato"
              className="form-control"
              value={formData.num_contrato}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Entidad *</label>
            <select
              name="id_entidad"
              className="form-select"
              value={formData.id_entidad}
              onChange={handleChange}
            >
              <option value="" hidden>Selecciona...</option>

              {entidades.map((e) => (
                <option key={e.id_entidad} value={e.id_entidad}>
                  {e.name}
                </option>
              ))}

            </select>
          </div>

        </div>

        {/* FILA 2 */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Presupuesto *</label>
            <input
              type="text"
              name="presupuesto"
              className="form-control"
              value={formData.presupuesto}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Valor contrato *</label>
            <input
              type="text"
              name="valor_contrato"
              className="form-control"
              value={formData.valor_contrato}
              onChange={handleChange}
            />
          </div>

        </div>

        {/* FILA 3 */}
        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Fecha inicio *</label>
            <input
              type="date"
              name="start_date"
              className="form-control"
              value={formData.start_date}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Fecha fin *</label>
            <input
              type="date"
              name="end_date"
              className="form-control"
              value={formData.end_date}
              onChange={handleChange}
            />
          </div>

        </div>

        {/* OBJETO */}
        <div className="mb-3">
          <label>Objeto *</label>
          <textarea
            name="objeto"
            className="form-control"
            rows={3}
            value={formData.objeto}
            onChange={handleChange}
          />
        </div>

        {/* DOCUMENTO */}
        <div className="mb-3">
          <label>Documento contrato (PDF o Word)</label>
          <input
            type="file"
            name="doc_contra_partida"
            className="form-control"
            accept=".pdf,.doc,.docx"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-outline-pink w-100 mt-3">
          Crear contrato
        </button>

      </form>
    </div>
  );
};

export default CreateContrato;